import React, { useEffect } from 'react';
import createD3 from './helpers/createD3';

import './index.css';

const createChart = () => {
  const chartContainer = document.getElementById('chart');

  if (chartContainer) {
    chartContainer.innerHTML = '';

    createD3();
  } else {
    this.createChart();
  }
};

const Graph = () => {
  useEffect(() => createChart());

  return (
    <div id="graph">
      <h1>Average Class Scores for Students</h1>
      <div id="chart" />
    </div>
  );
};

export default Graph;
